import type { IconData } from '@stacksjs/iconify-core'

export const toiletManSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 15a6.5 6.5 0 1 0 0-13a6.5 6.5 0 0 0 0 13m-9.475 1.748c2.256-.125 5.496-.248 9.475-.248s7.218.123 9.474.248c2.182.12 3.65 2.233 2.958 4.317c-1.511 4.548-3.336 8.683-4.57 11.294l-1.208 11.676c-.116 1.117-.967 2.034-2.104 2.17c-.512.06-1.125.125-1.795.178a1.48 1.48 0 0 1-1.59-1.422l-.375-8.982a.5.5 0 0 0-.5-.479h-.581a.5.5 0 0 0-.5.48l-.374 8.981a1.48 1.48 0 0 1-1.591 1.422a46 46 0 0 1-1.794-.179c-1.137-.135-1.989-1.052-2.104-2.169L16.138 32.36c-1.234-2.61-3.06-6.746-4.57-11.294c-.693-2.084.775-4.197 2.957-4.317\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default toiletManSolid
